const loadMore = {
	el: {
		buttonLoadMore: document.querySelector('.js-loadmore')
	},

	loadContent(el) {
		let numberOfItems = Number(el.dataset.results)
		const articles = el.parentElement.querySelectorAll('.search-results__article'),
			arrayArticles = [...articles]

		arrayArticles.forEach(el => el.style.display = 'none')

		arrayArticles.slice(0, numberOfItems).forEach(el => el.style.display = 'block')

	},

	events(el) {
		let numberOfItems = Number(el.dataset.results)
		const articles = el.parentElement.querySelectorAll('.search-results__article'),
			arrayArticles = [...articles]

		this.el.buttonLoadMore.addEventListener('click', e => {
			numberOfItems = numberOfItems + Number(el.dataset.results)
			arrayArticles.slice(0, numberOfItems).forEach(el => el.style.display = 'block')
			if (numberOfItems >= arrayArticles.length)
				e.currentTarget.style.display = 'none'
		})
	},

	init() {
		if (!this.el.buttonLoadMore) return
		this.events(this.el.buttonLoadMore)
		this.loadContent(this.el.buttonLoadMore)
	}
}

loadMore.init()